import { ILLUSTRATION_NAMES } from '../illustration/illustration.helper';

export interface ICurvedArrow {
  startX: number;
  startY: number;
  endX: number;
  endY: number;
  strokeColor?: string;
  strokeWidth?: number;
  arrowSize?: number;
  curvature?: number;
}

export type IArrow = Partial<ICurvedArrow> & {
  startSide: ARROW_POSITIONS;
  endSide: ARROW_POSITIONS;
  startOffset: number;
  endOffset: number;
};

export interface IHole {
  x: number;
  y: number;
  width: number;
  height: number;
  borderRadius?: number;
}

export interface IOverlayWithHoles {
  holes: IHole[];
  opacity: number;
  color: string;
}

export interface ITutorialCard {
  illustration: ILLUSTRATION_NAMES;
  text: string;
  ctaText: string;
  x: number;
  y: number;
  onPress?: () => void;
  withDot?: boolean;
  backgroundColor?: string;
}

export interface ITutorial {
  overlayColor?: string;
  overlayOpacity?: number;
}

export interface StepProps {
  targetArea: IHole;
  arrow: IArrow;
  tutorialCard: ITutorialCard;
}

export enum ARROW_POSITIONS {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}
